import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LoungeAccessItemComponent } from './lounge-access-item.component';
import { AmountFormatModule, StaticMsgModule } from '@lib/pipes';

@NgModule({
  declarations: [LoungeAccessItemComponent],
  imports: [CommonModule, StaticMsgModule, AmountFormatModule],
  exports: [LoungeAccessItemComponent],
})
export class LoungeAccessItemModule {}
